<template>
  <div class="sidebar-container flex flex-col">
    <Filters v-if="renderFilters()" :products="products" />
    <RequestQuote />
    <Links :organization="organization" :solutions="solutions" />
  </div>
</template>

<script>
import Filters from './helpers/filters.vue'
import RequestQuote from './helpers/request-quote.vue'
import Links from './helpers/links.vue'

export default {
  components: {
    Filters,
    RequestQuote,
    Links
  },
  props: {
    products:{
      type: Array,
      required: true
    },
    organization: {
      required: true,
      type: Object
    },
    solution: {
      required: true,
      type: Object
    },
    solutions: {
      required: true,
      type: Array
    }
  },
  methods: {
    renderFilters() {
      return (this.solution.title.includes('Rentals') || this.solution.title.includes('Sales'))
    }
  }
}
</script>

<style scoped>
.sidebar-container {
  width: 100%;
  padding-left: 0px;
  padding-right: 0px;
}
</style>